import "oj-event";
import { pause } from "oj-promise-utils";
import { cleanString, throttle } from "oj-utils";
import { getBoundingClientRectFrom } from "../../utils/dom";
import { dialog } from "./dialog";
import "./tooltipDialog.scss";
export function openTooltipDialog(options) {
    const { selector, className, eventName, rect: targetSize, content, onopen, onclose, onbeforeclose, onbeforeopen } = options;
    const el = document.querySelector(selector);
    const tooltip = dialog({
        className: cleanString(className, "-tooltip"),
        dismiss: false,
        backdrop: false,
        close: false,
        onbeforeclose,
        onbeforeopen,
        onopen,
        onclose,
        morph: () => {
            const rect = getBoundingClientRectFrom(el);
            return [
                rect,
                {
                    x: rect.x + (targetSize.x ?? 4),
                    y: rect.y + rect.height + (targetSize.y ?? 4),
                    width: targetSize.width,
                    height: targetSize.height,
                },
            ];
        },
    }, content);
    const p = pause(200);
    p.promise
        .then(() => {
        window.on(`pointerdown.${eventName}`, throttle(200, (ev) => {
            const root = ev.target.closest(".oj-AppDialog") || ev.target.closest(`.${className}`);
            if (!root)
                tooltip?.close();
        }));
    })
        .catch(() => { });
    tooltip.promise.finally(() => {
        window.off(`pointerdown.${eventName}`);
        p.reject();
    });
    return {
        close: async (event) => {
            p.reject();
            await tooltip.close(event);
        },
        promise: tooltip.promise,
    };
}
